// Kasa Yönetimi sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.cashbox';

export const cashboxGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Kasa Yönetimi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Nakit kasalarınızı tek yerden yönetirsiniz: kasa ekleme, para yatırma / çekme, gider girme, kasalar arası ve bankaya transfer bu ekrandan yapılır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    stats: t(`${G}.regions.stats`, 'Kasa özet kartları'),
    filters: t(`${G}.regions.filters`, 'Arama ve şube'),
    toolbar: t(`${G}.regions.toolbar`, 'Gider Ekle, Kasa Ekle, ⋮'),
    table: t(`${G}.regions.table`, 'Kasa listesi'),
  },
  steps: [
    {
      region: 'stats',
      title: t(`${G}.s1.title`, '1. Özet kartlarını okuyun'),
      text: t(`${G}.s1.text`, 'Üstteki kartlar Anlık Kasa Bakiyesi, Bugünkü Kasa Girişi, Bugünkü Kasa Çıkışı ve Net Günlük Durum değerlerini gösterir. Kasa bakiyesi, kasanın tüm giriş hareketlerinden çıkış hareketleri düşülerek hesaplanır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Şube yöneticisi olarak girdiyseniz özet kartları görünmez; listede yalnız kendi şubenizin kasaları bulunur.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Kasayı bulun'),
      text: t(`${G}.s2.text`, 'Başlıktaki huni düğmesi arama alanlarını açar. "Kasa Ara..." kutusuna kasa adını veya açıklamasını yazın; "Şube Filtrele" ile listeyi bir şubeye daraltın. Şube yöneticisinde şube kendi şubenize kilitlidir.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s3.title`, '3. Kasa ekleyin, ⋮ menüsünü kullanın'),
      text: t(`${G}.s3.text`, '"Kasa Ekle" yeni kasa açar: Kasa Adı zorunludur; Para Birimi, Şube (Opsiyonel) ve Açıklama girebilirsiniz. "Genel Kasa" adlı varsayılan kasa sistem tarafından otomatik oluşturulur ve listenin en başında durur.'),
      tips: [
        t(`${G}.s3.tip1`, 'Raporlar: tüm kasaların giriş / çıkış hareketlerini gösteren Kasa Hareket Raporu açılır.'),
        t(`${G}.s3.tip2`, 'Gider Türleri: kasadan gider girerken seçilecek türleri (ör. temizlik, kargo) tanımlarsınız.'),
        t(`${G}.s3.tip3`, 'Excel İndir: o an listede görünen kasaları Excel dosyasına aktarır.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. "İşlem Yap" ile para girişi ve çıkışı'),
      text: t(`${G}.s4.text`, 'Satırdaki "İşlem Yap" düğmesi kasanın bakiyesini ve dört işlemi gösterir: Para Yatır, Para Çek, Kasa Transferi, Banka Transferi. Para Yatır kasa bakiyesini artırır, Para Çek azaltır.'),
      tips: [
        t(`${G}.s4.tip1`, 'Para Çek: çekilecek miktar kasanın mevcut bakiyesinden büyük olamaz.'),
        t(`${G}.s4.tip2`, '"Geçmiş tarihli işlem yap" işaretlenirse hareket seçtiğiniz tarihe kaydedilir.'),
        t(`${G}.s4.tip3`, 'Kasa Transferi aynı para birimindeki başka bir kasaya, Banka Transferi aynı para birimindeki bir banka hesabına para aktarır.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s5.title`, '5. Kasadan gider ekleyin'),
      text: t(`${G}.s5.text`, 'Kırmızı "Gider Ekle" düğmesi, kasadan nakit alınarak yapılan harcamayı (temizlik malzemesi, kargo ücreti vb.) kaydeder. Tutar seçilen kasanın bakiyesinden düşülür ve Kasa Hareket Raporunda gider olarak görünür.'),
      tips: [
        t(`${G}.s5.tip1`, 'Şube yöneticisi bu düğmeyi yalnız gider ekleme yetkisi varsa görür.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Satırdaki ⋮ menüsü: düzenle, sil, transfer'),
      text: t(`${G}.s6.text`, 'Satırın sonundaki ⋮ düğmesi Kasa Transferi, Banka Transferi, Düzenle ve Sil seçeneklerini açar.'),
      tips: [
        t(`${G}.s6.tip1`, 'Varsayılan kasa (Genel Kasa) ve hareketi olan kasalar düzenlenemez ve silinemez; menüde "(Varsayılan kasa)" veya "(Hareket var)" yazar.'),
        t(`${G}.s6.tip2`, 'Silme işlemi geri alınamaz.'),
        t(`${G}.s6.tip3`, 'Şube yöneticisi kasalar üzerinde düzenleme, silme veya transfer yapamaz; bu düğmeler ona görünmez.'),
      ],
    },
  ],
});
